"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectModelJs = require("@zerobytes/object-model-js");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var WorkflowExpiration =
/*#__PURE__*/
function (_ShapeBase) {
  _inherits(WorkflowExpiration, _ShapeBase);

  function WorkflowExpiration(data) {
    var _this;

    _classCallCheck(this, WorkflowExpiration);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WorkflowExpiration).call(this, data));
    _this.$fieldConfig = {
      doesExpire: {
        type: "string",
        validate: function validate() {
          return true;
        }
      },
      daysToExpiration: {
        type: "string",
        validate: function validate() {
          return true;
        }
      },
      daysToFirstWarning: {
        type: "string",
        validate: function validate() {
          return true;
        }
      },
      daysToLastWarning: {
        type: "string",
        validate: function validate() {
          return true;
        }
      },
      expirationConsequence: {
        type: _objectModelJs.FieldTypes.String,
        defaultValue: 'ignore',
        validate: function validate() {
          return true;
        }
      }
    };

    _this.$fill(data);

    return _this;
  }

  return WorkflowExpiration;
}(_objectModelJs.ShapeBase);

var _default = WorkflowExpiration; // import { ShapeBase, FieldTypes, FieldType, Validator } from '@zerobytes/object-model-js';
// class WorkflowExpiration extends ShapeBase {
// 	constructor(data) {
// 		super(data);
// 		this.$fieldConfig = {
// 			doesExpire: {
// 				type: FieldTypes.String,
// 				minLength: 5,
// 				validate: () =>
// 					Validator(this, 'doesExpire')
// 						.isOfType()
// 						.notEmpty()
// 						.notNull()
// 						.minLength()
// 						.isValid()
// 			},
// 			daysToExpiration: {
// 				type: FieldTypes.String,
// 				minLength: 5,
// 				validate: () =>
// 					Validator(this, 'daysToExpiration')
// 						.isOfType()
// 						.notEmpty()
// 						.notNull()
// 						.minLength()
// 						.isValid()
// 			},
// 			daysToFirstWarning: {
// 				type: FieldTypes.String,
// 				minLength: 5,
// 				validate: () =>
// 					Validator(this, 'daysToFirstWarning')
// 						.isOfType()
// 						.notEmpty()
// 						.notNull()
// 						.minLength()
// 						.isValid()
// 			},
// 			daysToLastWarning: {
// 				type: FieldTypes.String,
// 				minLength: 5,
// 				validate: () =>
// 					Validator(this, 'daysToLastWarning')
// 						.isOfType()
// 						.notEmpty()
// 						.notNull()
// 						.minLength()
// 						.isValid()
// 			}
// 		};
// 		this.$fill(data);
// 	}
// }
// export default WorkflowExpiration;

exports["default"] = _default;